import React from 'react';
import { A, ComingSoon, Flex } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { useAppConfig } from '../appConfig';

const { FormattedMessage } = Intl;

const Timesheets = () => {
  const appConfig = useAppConfig();
  const redirectToErecruit = () =>
    window.open(appConfig?.REACT_APP_ERECRUIT_URL);

  return (
    <ComingSoon
      title={<FormattedMessage id={messageIds.vms.timesheets.title} />}
      description={
        <Flex justify="flex-end">
          <FormattedMessage id={messageIds.vms.timesheets.description} />
          &nbsp;
          <A textDecoration="underline" onClick={redirectToErecruit}>
            <FormattedMessage id={messageIds.vms.timesheets.legacyPortal} />
          </A>
        </Flex>
      }
    />
  );
};

export default Timesheets;
